import React from 'react';
import { Alert } from 'reactstrap';

const ProgressReport = ({ result = {} }) => {
  const {
    success = true,
    processedCount = 0,
    errorCount = 0,
    errors = []
  } = result;

  // Determine the alert type and message based on the result
  const getAlertConfig = () => {
    if (success && errorCount === 0) {
      return {
        color: 'success',
        title: 'Procesamiento completado exitosamente'
      };
    } else if (success && errorCount > 0) {
      return {
        color: 'warning',
        title: 'Procesamiento completado con errores'
      };
    } else if (!success && processedCount > 0 && errorCount > 0) {
      return {
        color: 'warning',
        title: 'Procesamiento completado con errores'
      };
    } else {
      return {
        color: 'danger',
        title: 'Error en el procesamiento'
      };
    }
  };

  const alertConfig = getAlertConfig();

  return (
    <Alert color={alertConfig.color} className="mt-3">
      <h6>{alertConfig.title}</h6>
      
      <div className="mb-2">
        <strong>Registros procesados: {processedCount}</strong>
      </div>
      
      {errorCount > 0 && (
        <div className="mb-2">
          <strong>Errores encontrados: {errorCount}</strong>
        </div>
      )}
      
      {errors && errors.length > 0 && (
        <div>
          <p><strong>Errores de validación encontrados:</strong></p>
          <ul className="mb-0">
            {errors.map((error, index) => (
              <li key={index}>
                {error.errors.map((err, errIndex) => (
                  <div key={errIndex}>{err}</div>
                ))}
              </li>
            ))}
          </ul>
        </div>
      )}
    </Alert>
  );
};

export default ProgressReport;
